import React, { useState, useRef, useCallback, createContext } from 'react'
import { Row, Col, Space } from 'antd'
import { connect } from 'dva'

import Query from './components/Query'
import Actions from './components/Actions'
import Table from './components/Table'
import styles from './index.less'

import { queryOperation } from '@/services/docking'

export * from './helper'

export const Context = createContext()

export default connect()(({ dispatch }) => {
    const [query, setQuery] = useState({})

    const [selected, setSelected] = useState([])

    const $list = useRef(null)

    const fetchTable = useCallback(
        params => {
            return queryOperation({ ...query, ...params })
        },
        [query]
    )

    const reload = () => {
        $list.current && $list.current.reload()
    }

    const refresh = () => {
        $list.current && $list.current.refresh()
    }

    const create = () => {
        $list.current && $list.current.create()
    }

    const clearSelected = () => {
        setSelected([])
    }

    const rowSelection = {
        fixed: true,
        selectedRowKeys: selected,
        onChange: keys => setSelected(keys)
    }

    return (
        <Context.Provider
            value={{
                create,
                reload,
                refresh,
                selected,
                clearSelected
            }}>
            <Space className={styles.container} direction="vertical" size={20}>
                <Row justify="space-between">
                    <Col>
                        <Query value={query} onChange={setQuery} />
                    </Col>
                    <Col>
                        <Actions />
                    </Col>
                </Row>

                <Table ref={$list} dispatch={dispatch} fetch={fetchTable} rowSelection={rowSelection} />
            </Space>
        </Context.Provider>
    )
})
